import { useCallback, useState } from 'react';
import { useSupplierOfferCardListQuery } from 'api';
import { useParams } from 'react-router-dom';

export const useSupplierOffers = () => {
  const [addSupplierOfferModalState, setAddSupplierOfferModalState] = useState<boolean>(false);
  const [sort, setSort] = useState<string | undefined>('LATEST');
  const { id } = useParams() as { id: string };
  const { data = [], isLoading } = useSupplierOfferCardListQuery({ purchaseId: id, sort });
  const onAddSupplierOfferModalStateChange = useCallback(() => {
    setAddSupplierOfferModalState((prevState) => !prevState);
  }, []);

  const handleSortChange = useCallback((value: string) => {
    setSort(value);
  }, []);
  return {
    addSupplierOfferModalState,
    onAddSupplierOfferModalStateChange,
    handleSortChange,
    sort,
    data,
    isLoading,
  };
};
